'use client';

import { Button, cn, Label, RadioGroup, RadioGroupItem } from '@shared/components/shadcn';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { useState } from 'react';
import type { LandingPods } from '../../types/landingPods';

function LandingPodItems({ landingPods }: { landingPods: LandingPods }) {
  const [selectedPodTitle, setSelectedPodTitle] = useState(landingPods.pods[1]?.title);
  const t = useTranslations('offer-choice');
  const baseLink = landingPods.pods.find(pod => pod.title === selectedPodTitle)?.link ?? '';

  const selectedPodLink = (() => {
    if (!baseLink) return '';
    const url = new URL(baseLink, 'https://temporalhost.com');
    url.searchParams.set('deposit', 'true');
    return `${url.pathname}${url.search}`;
  })();

  return (
    <>
      <RadioGroup value={selectedPodTitle} onValueChange={setSelectedPodTitle} data-track-container="Promo Pods">
        {landingPods.pods.map((pod, index) => (
          <div
            className={cn(
              'cursor-pointer bg-container-base flex items-center gap-3 hover:text-foreground-subtle p-5 rounded-md border border-border hover:border-border-active',
              selectedPodTitle === pod.title ? 'border-border-active' : 'border-border'
            )}
            key={pod.title}
            data-testid="offer-pod"
            onClick={() => setSelectedPodTitle(pod.title)}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                setSelectedPodTitle(pod.title);
              }
            }}
            data-track-container="Offer"
          >
            <RadioGroupItem id={index.toString()} value={pod.title} className="w-7 h-7" data-track-name="Offer" data-track-title={pod.title} data-track-code={pod.link} />
            <Label className="paragraph-strong hover:text-inherit" htmlFor={index.toString()}>
              {pod.title}
            </Label>
          </div>
        ))}
      </RadioGroup>

      <p className="paragraph-s text-foreground-subtle" data-testid="offer-terms">
        {landingPods.highLevelTermsAndConditions}
      </p>

      <div className="mt-auto md:mt-0" data-track-container="Actions">
        <Button
          variant="primary"
          className="w-full"
          asChild
          data-testid="offer-cta-button"
          data-track-name="Opt In"
          data-track-title={selectedPodTitle}
          data-track-code={selectedPodLink}
        >
          <Link href={selectedPodLink}>{t('cta')}</Link>
        </Button>
      </div>
    </>
  );
}

export { LandingPodItems };
